// extracted by mini-css-extract-plugin
module.exports = {"product-prescription-drawer":"ProductPrescriptionDrawer_product-prescription-drawer__xMImL"};